@use 'src/globals/main';

$delay: 0.15s;

pn-tooltip {
  display: inline-block;
  font-size: 1em;
}

pn-tooltip .pn-tooltip {
  background: none;
  background-color: transparent;
  border: none;
  position: relative;
  padding: 0;
  border-radius: 50%;

  @include main.pn-transition('outline-color, background-color');

  cursor: pointer;
  font-size: inherit;

  @include main.pn-focus(main.$blue700, main.$blue50);

  &:hover {
    background-color: main.$blue50;
  }

  &[data-light] {
    pn-icon .pn-icon-svg path {
      fill: main.$white;
    }
    &:focus,
    &:hover {
      background-color: rgba(main.$white, 0.2);
    }
  }

  &[data-warning] {
    pn-icon .pn-icon-svg path {
      fill: main.$warning;
    }

    @include main.pn-focus(main.$warning, main.$coral50);

    &:hover {
      background-color: main.$coral50;
    }
  }
  &-content {
    position: absolute;
    text-align: left;
    bottom: calc(100% + 0.75em);
    left: 50%;
    background: main.$white;
    padding: 1em;
    border-radius: 0.8rem;
    box-shadow:
      0 1.2px 3.6px rgba(0, 0, 0, 0.1),
      0 6.4px 14.4px rgba(0, 0, 0, 0.13);
    z-index: 1;
    max-width: min(95vw, 40em);

    @include main.pn-transition('transform');
    transition-delay: $delay;

    transform: scale(0) translateX(-50%);
    transform-origin: bottom left;
    width: max-content;
    color: main.$gray900;

    &[data-simple] {
      background: main.$blue900;
      color: main.$white;
      border-radius: 10em;
      padding: 0.5em 0.85em;
      bottom: 100%;
      font-size: 0.875em;
      font-weight: 300;
      margin-bottom: 0.1em;
      margin-top: 0.1em;
    }
  }

  > pn-icon {
    position: relative;
    pointer-events: none;

    &:before {
      content: '';
      pointer-events: none;
      width: 0;
      height: 0;
      border-left: 0.75em solid transparent;
      border-right: 0.75em solid transparent;
      border-top: 0.75em solid main.$white;
      filter: drop-shadow(0 0.3rem 0.1rem rgba(0, 0, 0, 0.075));
      bottom: 102%;
      left: 50%;
      position: absolute;
      z-index: 2;

      @include main.pn-transition('transform');
      transition-delay: 0;

      transform: scale(0) translateX(-50%);
      transform-origin: top left;
    }
    &[data-simple]:before {
      content: none;
    }
  }

  &[data-open] {
    .pn-tooltip-content {
      transition-delay: 0;
    }

    pn-icon:before {
      transform: scale(1) translateX(-50%);
      transition-delay: $delay;
      pointer-events: auto;
    }
  }

  &[data-downwards] {
    .pn-tooltip-content {
      bottom: unset;
      top: calc(100% + 0.75em);
      transform-origin: top left;
    }

    pn-icon:before {
      top: 102%;
      transform-origin: bottom left;
      filter: drop-shadow(0 -0.3rem 0.1rem rgba(0, 0, 0, 0.02));
      border-top: none;
      border-bottom: 0.75em solid main.$white;
    }
  }
}
